var CartComponent = class extends HTMLElement {  
    constructor() {
        super();    
        // bind the context of "this" to avoid losing it inside the handler.
        this.moveElement = this.moveElement.bind(this);
    }

    connectedCallback() {
        this.shippingBar = this.querySelector(".shipping-bar");
        this.cartAsideInner = this.querySelector(".cart__aside-inner");
        this.cartContent = this.querySelector(".cart__content");
        
        this.cartAside = this.querySelector(".cart__aside");
        if(this.cartAside) {
            this.initialPosition = this.cartAside.offsetTop;
        }

        // create an observer instance
        const observer = new MutationObserver(() => this.moveElement());
        const config = { attributes: true, childList: true, characterData: true, subtree: true };

        // pass in the target node, as well as the observer options
        observer.observe(document.body, config);

        window.addEventListener('resize', this.moveElement);
        
        // Call moveElement initially to handle the case when the page loads
        this.moveElement();
        
    }

    moveElement() {       
        if (window.matchMedia('(max-width: 999px)').matches) {
            if(this.shippingBar && this.shippingBar.parentNode !== this.cartContent) {
                this.cartContent.prepend(this.shippingBar); // change here
            }
        } else {
            if(this.shippingBar && this.shippingBar.parentNode !== this.cartAsideInner) {
                this.cartAsideInner.prepend(this.shippingBar); // change here 
            } 
        }
     
    }
};
window.customElements.define("cart-component", CartComponent);
     